import { groupBy } from 'lodash/';
import { EventEmitter } from 'eventemitter3';
import { TradesQueue } from './TradesQueue';
import { Trade, Side, Exchange, AlertData, VolumePerPeriod } from '@/types/trade';

const groupBySide = (trades: Trade[]) => {
  return groupBy(trades, (v) => {
    return v.side;
  });
};
const groupBySecond = (trades: Trade[], seconds: number) => {
  return groupBy(trades, (v) => {
    return Math.floor(v.timestamp / seconds);
  });
};
const sumSize = (trades: Trade[]) => {
  if (trades) {
    return trades.reduce((pre, cur) => {
      return pre + cur.size;
    }, 0);
  }
  return 0;
};
// TODO: Refactoring
// BUY/SELL処理を共通化
const convertTradesToVolumeHistory = (trades: Trade[], seconds: number) => {
  const tradesBySide = groupBySide(trades);
  let buyVolumeHistory: VolumePerPeriod[] = [];
  let sellVolumeHistory: VolumePerPeriod[] = [];
  if (tradesBySide.BUY) {
    const groupedBySecond = groupBySecond(tradesBySide.BUY, seconds);
    buyVolumeHistory = Object.entries(groupedBySecond).map((v) => {
      const totalSize = sumSize(v[1]);
      return {
        timestamp: +v[0],
        size: totalSize,
      };
    });
  }
  if (tradesBySide.SELL) {
    const groupedBySecond = groupBySecond(tradesBySide.SELL, seconds);
    sellVolumeHistory = Object.entries(groupedBySecond).map((v) => {
      const totalSize = sumSize(v[1]);
      return {
        timestamp: +v[0],
        size: totalSize,
      };
    });
  }
  return {
    BUY: buyVolumeHistory,
    SELL: sellVolumeHistory,
  };
};

export class Trades extends EventEmitter {
  private lastPrice?: number;
  private trades: TradesQueue;
  private tradesForAlert: {
    BUY: TradesQueue;
    SELL: TradesQueue;
  };
  constructor(
    private exchangeName: Exchange,
    maintainPeriod: number,
    alertPeriod: number,
    private alertVolume: number,
  ) {
    super();
    this.trades = new TradesQueue(maintainPeriod);
    this.tradesForAlert = {
      BUY: new TradesQueue(alertPeriod),
      SELL: new TradesQueue(alertPeriod),
    };
  }
  get exchange() {
    return this.exchangeName;
  }
  public addTrade(trade: Trade) {
    if (!trade.direction) {
      if (this.lastPrice) {
        trade.direction = trade.price - this.lastPrice;
      } else {
        trade.direction = 0;
      }
    }
    this.lastPrice = trade.price;

    this.trades.enqueue(trade);
    this.tradesForAlert[trade.side].enqueue(trade);
    this.checkAlert(trade.side);
   }
  public getVolumePerPeriod(period: number) {
    const tradesForVolumePerPeriod = this.trades.getTrades(period);
    const { BUY, SELL } = groupBySide(tradesForVolumePerPeriod);
    return {
      BUY: sumSize(BUY),
      SELL: sumSize(SELL),
    };
  }
  public getVolumeHistory(period: number) {
    const trades = this.trades.getTrades();
    const volumeHistory = convertTradesToVolumeHistory(trades, period);
    return volumeHistory;
  }
  public getTimeAndSales() {
    return [...this.trades.getTrades()];
  }
  private checkAlert(side: Side) {
    const volumeForAlert = sumSize(this.tradesForAlert[side].getTrades());
    if (volumeForAlert > this.alertVolume) {
      this.tradesForAlert[side].clear();
      const alertData: AlertData = {
        exchange: this.exchangeName,
        side,
        size: volumeForAlert,
        timestamp: Date.now(),
      };
      this.emit('alert', alertData);
    }
  }
}
